/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { useEffect } from 'react';
import { withRouter, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { paddingLeft } from '@/utils/directions';
import { changeMobileSidebarVisibility } from '@/redux/actions/sidebarActions';
import { changeThemeToDark, changeThemeToLight } from '@/redux/actions/themeActions';
import PharmaCrowdWalletHeader from '../Layout/CustodiyWalletHeader';
import Sidebar from './components/sidebarNew/Sidebar';

const Layout = () => {
  const {
    customizer, sidebar, theme, rtl, isLoggedIn,
  } = useSelector(state => ({
    customizer: state.customizer,
    sidebar: state.sidebar,
    theme: state.theme,
    rtl: state.rtl,
    isLoggedIn: state.user?.isLoggedIn || false,
  }));

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const hideSidebar = location.pathname === '/' || !isLoggedIn;

  // Redirect to sign-in if not logged in (except for public routes)
  useEffect(() => {
    const publicRoutes = ['/', '/sign-in', '/sign-up'];
    const isPublicRoute = publicRoutes.includes(location.pathname);
    
    if (!isLoggedIn && !isPublicRoute) {
      history.push('/sign-in');
    }
  }, [isLoggedIn, location.pathname, history]);

  const mobileSidebarVisibility = () => {
    dispatch(changeMobileSidebarVisibility());
  };

  const changeToDark = () => {
    dispatch(changeThemeToDark());
  };

  const changeToLight = () => {
    dispatch(changeThemeToLight());
  };

  return (
    <LayoutContainer
      collapse={sidebar.collapse}
      topNavigation={customizer.topNavigation}
    >
      {/* <Customizer
        changeSidebarVisibility={sidebarVisibility}
        changeToLight={changeToLight}
        changeToDark={changeToDark}
      /> */}
      {/* New Wallet Header - always shown */}
      <PharmaCrowdWalletHeader />
     
      {!hideSidebar && (
        <Sidebar
          sidebar={sidebar}
          changeToDark={changeToDark}
          changeToLight={changeToLight}
          changeMobileSidebarVisibility={mobileSidebarVisibility}
          topNavigation={customizer.topNavigation}
        />
      )}

    </LayoutContainer>
  );
};


export default withRouter(Layout);

// region STYLES

const LayoutContainer = styled.div`
  & + div {
    ${props => props.collapse && `
      ${paddingLeft(props)}: 0;
    `};

    @media screen and (min-width: 576px) {
      ${props => props.collapse && `
        ${paddingLeft(props)}: 60px;
      `}

      ${props => props.topNavigation && `
         ${paddingLeft(props)}: 0;
      `}
    }
  }
`;

// endregion
